import * as React from 'react';
type Props = {
  className?: string;
};
export function WhiteFish({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-WhiteFish"
      className={className}
    >
      <path
        d="M1.51322 24.9567C4.45618 22.4751 17.6142 13.1928 39.6836 23.613C40.2259 23.8691 40.8705 23.887 41.4217 23.647L48.75 20.4553L44.8546 24.4643C44.1613 25.1779 44.1497 26.2476 44.8275 26.9733L48.75 31.1743L41.5247 27.7255C40.9291 27.4412 40.219 27.4585 39.639 27.7687C35.4318 30.0184 17.353 38.4056 1.53695 26.0519C1.16417 25.7608 1.15286 25.2606 1.51322 24.9567Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.30903 26.0196C6.68021 26.0196 6.98113 25.6799 6.98113 25.2609C6.98113 24.8419 6.68021 24.5022 6.30903 24.5022C5.93786 24.5022 5.63696 24.8419 5.63696 25.2609C5.63696 25.6799 5.93786 26.0196 6.30903 26.0196Z"
        fill="currentColor"
      />
      <path
        d="M10.7816 23.2966C10.7816 23.2966 12.326 25.9075 10.7816 28.3499"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.575 25.2607L19.6372 28.395C19.9887 28.6662 19.7168 29.1863 19.2642 29.1084L15.0386 28.3805"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0031 31.6943L32.1516 33.7871L35.3002 29.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8856 19.4059C27.9383 18.1675 27.5052 16.6624 27.6639 15.1597L27.6808 15L17.9867 18.6981"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
